<script>
    import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { commitHistory } from "@app/store/historyStore.svelte.js";
    import compressText from "@cclib/functions/quill/compressText.js";
    import { toast } from "@zerodevx/svelte-toast";
    import * as m from '@app/paraglide/messages.js';

    let isDisabled = $derived(!eventGroupState[projectState.selected] ||
        eventGroupState[projectState.selected].selected.length === 0 ||
        isSelectedEventGroupLocked());

    /* Compressions makes the event longer which requires us to remove a word from the longest line and move it to a shorter line*/
    const compressEvent = function () {
        if (!eventGroupState[projectState.selected]) {
            return;
        }

        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        if (
            !eventGroupState[projectState.selected].selected ||
            eventGroupState[projectState.selected].selected.length === 0
        ) {
            return;
        }

        const egIdx = projectState.selected;
        const selected = [...eventGroupState[egIdx].selected];
        const maxChars = eventGroupState[egIdx].maxChars;
        const maxLines = eventGroupState[egIdx].maxLines;

        commitHistory({
            name: "compress event(s)",
            eventGroup: egIdx,
            mutate: {
                eventGroupState: (draft) => {
                    selected.forEach((eventIndex) => {
                        try {
                            const ev = draft[egIdx].events[eventIndex];
                            if (!ev?.text) {
                                return;
                            }
                            ev.text = compressText(ev.text, maxChars, maxLines);
                        } catch (err) {
                            console.error(err);
                        }
                    });
                },
            },
        });

        const firstIdx = selected[0];
        if (firstIdx !== undefined && window.quillEditor) {
            const text = eventGroupState[egIdx].events[firstIdx]?.text;
            if (text && window.quillEditor.getSemanticHTML() !== text) {
                let delta = window.quillEditor.clipboard.convert({ html: text });
                window.quillEditor.setContents(delta, "silent");
                window.quillEditor.formatLine(
                    0,
                    9999,
                    "align",
                    eventGroupState[egIdx].events[firstIdx].alignment === "left"
                        ? ""
                        : eventGroupState[egIdx].events[firstIdx].alignment,
                    "silent",
                );
            }
        }
    };
</script>

<li class="nav-item" title={m.compress_title()}>
    <a
        class="nav-link"
        href="#!/"
        id="compress-text-btn"
        role="button"
        aria-label={m.compress_aria_label()}
        aria-disabled={isDisabled}
        onclick={compressEvent}
        class:disabled={isDisabled}
        ><i class="bi bi-distribute-horizontal"></i></a
    >
</li>
